<styles-smart-table
  #smartTable
  [datasource]="campaign.items"
  [expandable]="expandable"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [expandedColumns]="['details']"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="type">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div style="position: relative; top: 5px">{{$any(element)?.type }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="image"></th>
    <td
      mat-cell
      *matCellDef="let element"
      [attr.rowspan]="smartTable.getImageRows(element)"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="image"
    >
      <framework-assets-image
        image
        [assetSet]="$any(element)?.defaultAsset"
        [size]="130"
        [style.height.px]="smartTable.isExpanded(element) ? 124 : 44"
      >
      </framework-assets-image>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="date">Date</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="date">
      <styles-icon-value-caption
        caption="Due date"
        icon="date_range"
        *ngIf="element.status.id !== 'Completed'; else completed"
      >
        {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      <ng-template #completed>
        <styles-icon-value-caption caption="Completion date" icon="date_range">
          {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      <styles-icon-value-caption caption="Organization" icon="corporate_fare" *ngIf="element.feedDetails">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let element" [attr.colspan]="5">
      <div class="details-flex-wrapper">
        <framework-clusted-profile-images [userList]="$any(element)?.members" [numberToShow]="10">
        </framework-clusted-profile-images>

        <framework-tag-chip *ngFor="let tag of $any(element).tags" [tag]="tag"> </framework-tag-chip>

        <styles-icon-value-caption caption="Campaign" icon="campaign" *ngIf="$any(element)?.campaign">
          {{ $any(element).campaign.name }}
        </styles-icon-value-caption>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="default">Name</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div class="title ellipsis-text">{{$any(element)?.name }}</div>

        <framework-master-project-progress-line
          [masterProject]="element"
          [rounding]="true"
          [stroke]="6"
          [gap]="3"
          *ngIf="(element | workInType : 'MasterProject') && (element | masterSpaceTaskCount); else nativeProduction"
        >
        </framework-master-project-progress-line>

        <ng-template #nativeProduction>
          <framework-space-progress-line [space]="element" [rounding]="true" [stroke]="6">
          </framework-space-progress-line>
        </ng-template>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="status">Status</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip [workStatus]="$any(element)?.status"></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner">Owner</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>
</styles-smart-table>
